import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { BrandReportService } from './brand-reports.service';
import { ProjectsService } from 'app/_services/projects.service';
import * as html2pdf from 'html2pdf.js';
const moment = require('moment');
@Component({
  selector: 'app-brands',
  templateUrl: './brand-reports.component.html',
  styleUrls: ['./brand-reports.component.scss']
})
export class BrandReportsComponent implements OnInit {
  discussProject = [];
  selectedDiscussProjects = [];
  isLoading = false;
  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];
  sourceByTopic = "";

  typeTime = 'create_date';

  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  isLoadingReport = false ;

  typeReport = 'day';
  typeReportFilter = 'day';
  notSpam = false;
  isBussinessCenter =  false;
  typeAction = 'create';

  typeComment = 'comment';

  dtOptions: DataTables.Settings = {};
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().startOf('day'),
    end: moment().endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };

  options = {
    locale: { format: 'DD/MM/YYYY HH:mm:ss' },
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  keyword = '';

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };


  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private brandReportService: BrandReportService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
    // this.getProjectDiscussion();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: true,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: true,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      idField: 'item_id',
      singleSelection: true,
      enableSearchFilter: true,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate =  this.daterange.end;
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  onProjectSelectedChange() {
    console.log("baont : onProjectSelectedChange : ", this.projectSelected)
    
  }

  projectSelectedChange(){
    this.projectsService.getProjectDiscussionByProject( {projects : this.projectSelected}).subscribe(res => {
      this.discussProject = [];
      this.selectedDiscussProjects = [];
      if (res.success) {
        res.data.projectsDiscussion
        .forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.discussProject.push(obj);
        });
      }
    })
  }

  async exportPDF() {
    this.isLoading = true;
    let totalExported = 0;
    let pages = Array.from(window.document.getElementsByClassName('container-page'));

    const options = {
      margin: 0,
      filename: `bao_cao_tong_quan.pdf`,
      image: { type: 'jpeg', quality: 1 },

      html2canvas: { dpi: 250, scrollX: 0, scrollY: 0, width: 1587, height: 1122 },
      jsPDF: { orientation: 'landscape', format: 'a3' }
    }
    let worker = html2pdf().set(options).from(pages[0]);
    totalExported++;
    if (totalExported == pages.length) {
      this.isLoading = false;
    }
    if (pages.length > 1) {
      worker = worker.toPdf() // worker is now a jsPDF instance

      // add each element/page individually to the PDF render process
      pages.slice(1).forEach((element, index) => {
        worker = worker
          .get('pdf')
          .then(pdf => {
            pdf.addPage();
            totalExported++;
            if (totalExported == (pages.length)) {
              this.isLoading = false;
            }
          })
          .from(element)
          .toContainer()
          .toCanvas()
          .toPdf()
      })
    }

    worker = worker.save();

  }


  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    // let await1s = await this.resolveAfter1Seconds()
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        const _projects = response.data.projects
        for (let index in _projects){
          const projectItem = {
            item_id: index,
            id: _projects[index]._id,
            itemName: _projects[index].name,
            value: _projects[index].name
          };
          this.projects.push(projectItem);
        }
        console.log("this.projects : ", this.projects)
        // response.data.projects.forEach(element => {
        //   let projectItem = {
        //     id: element._id,
        //     itemName: element.name,
        //     value: element.name
        //   };
        //   this.projects.push(projectItem);
        // });
      }
    });

  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.brandReportService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  // getProjectDiscussion() {
  //   this.projectsService.getProjectDiscussionByProject({ projects: [] }).subscribe(response => {
  //     if (response.success && response.data.projectsDiscussion) {
  //       response.data.projectsDiscussion.forEach(element => {
  //         const projectItem = {
  //           id: element._id,
  //           itemName: element.name,
  //           value: element.name
  //         };
  //         this.discussProject.push(projectItem);
  //       });
  //     }
  //   });
  // }

  getReportManager() {

    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      typeReport: this.typeReportFilter,
      report_code: ["BCTQ"]
    };
    this.dataTableShow = false;
    this.brandReportService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }

  clickReport() {
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    this.dataReport = {};
    this.isLoadingReport = true ;
    console.log(this.isLoadingReport)
    //let timeRange = Math.ceil((this.daterange.end.valueOf() - this.daterange.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }
    let gte = this.daterange.start.valueOf();
    if (this.typeReport == "day") {
      // gte -= 6 * 24 * 60 * 60 * 1000;
    }
    let filter = {
      from: this.daterange.start.valueOf(),
      gte: gte,
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      selectedDiscussProjects : this.selectedDiscussProjects,
      type: this.typeReport,
      sourceByTopic: this.sourceByTopic,
      notSpam: this.notSpam,
      isBussinessCenter : this.isBussinessCenter,
      keyword: this.keyword,
      typeTime: this.typeTime
    };
    this.brandReportService.getReport({ filter: filter, index: "full" }).subscribe(response => {

      const data = response.data;
      if (data) {
        const aggregations = data.aggregations;
        //bai viet, binh luan, chia se, quan tam
        const commentCount = aggregations.dataFilter.post.numComments.value;
        const postCount = aggregations.dataFilter.post.doc_count;
        const shareCount = aggregations.dataFilter.post.shareCount.value;
        const likeCount = aggregations.dataFilter.post.likeCount.value;
        const newsCount = aggregations.dataFilter.news.doc_count;
        const numReactionsCount = aggregations.dataFilter.post.numReactions.value;
       // let viewCount = aggregations.dataFilter.post.viewCount.value;
        // if(this.typeComment == 'post') {
          // likeCount = likeCount + numReactionsCount;
        //}

        const interactiveCount =   commentCount + shareCount + numReactionsCount  +  likeCount + postCount + newsCount ;



        const facebookCount = aggregations.dataFilter.facebook.doc_count;
        const youtubeCount = aggregations.dataFilter.youtube.doc_count;
        const tiktokCount = aggregations.dataFilter.tiktok.doc_count;
        const instagramCount = aggregations.dataFilter.instagram.doc_count;
        const linkedinCount = aggregations.dataFilter.linkedin.doc_count;
        const twitterCount = aggregations.dataFilter.twitter.doc_count;

        const sentimentsCount = aggregations.dataFilter.sentimentsCount.statistic.seg.buckets;
        const sentiment = {};
        for (var i = 0; i < sentimentsCount.length; i++) {
          sentiment[sentimentsCount[i].key] = sentimentsCount[i].doc_count;
        }
        const byDay = Array();
        const dataByDay = aggregations.byDay.buckets;
        for (var i = 0; i < dataByDay.length; i++) {
          let obj = {
            key: dataByDay[i].key_as_string,
            post: dataByDay[i].post.doc_count,
            comment: dataByDay[i].comment.doc_count
          }
          byDay.push(obj);
        }
        this.dataReport = {
          report_desc: "Báo cáo tổng quan",
          report_type: this.typeReport,
          report_name: "Báo cáo tổng quan từ ngày " + this.daterange.start.format('DD/MM/YYYY') + " đến ngày " + this.daterange.end.format('DD/MM/YYYY'),
          report_project: this.projectSelected,
          report_brand: this.brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCTQ",
          data: {
            commentCount: commentCount,

            postCount: postCount,
            newsCount: newsCount,

             facebookCount : facebookCount,
             youtubeCount : youtubeCount,
             tiktokCount : tiktokCount,
             instagramCount : instagramCount,
             linkedinCount : linkedinCount,
             twitterCount :twitterCount,
            sentiment: sentiment,
            shareCount: shareCount,
            likeCount: likeCount,
            // viewCount : viewCount,
            interactiveCount : interactiveCount,
            numReactionsCount : numReactionsCount,
            byDay: byDay
          }
        }
      }
      this.isLoadingReport = false ;
      // console.log(this.isLoadingReport)
    });

    // console.log(filter);
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.brandReportService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.brandReportService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  onItemProjectSelect(item: any) {
    console.log("baont : onItemSelect : ", item)
    this.projectSelected = [item]
    this.projectSelectedChange()
  }
  onItemProjectDeSelect(item: any) {
    this.projectSelected = []
    this.projectSelectedChange()
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/brand-report/brand-reports.component.ts